
export function generarInscripcionesR( inscripciones,fechas,data_user ){
  window.console.log( "Inscr ",inscripciones,fechas,data_user );
  var fi = parseFecha( fechas.fecha_ini );
  var ff = parseFecha( fechas.fecha_fin );
  if( !data_user.seg_apellido ) data_user.seg_apellido = '';
  var us = data_user.nombres+' '+data_user.pri_apellido+' '+data_user.seg_apellido;
  var doc = new window.jsPDF({ orientation: 'l',
    unit: 'px',
    format: 'letter',
    fontSize: 1,
    putOnlyUsedFonts:false 
  }); 
  doc.cellInitialize();

  doc.addFont('ArialMS', 'Arial', 'normal');
  doc.setFont('Arial');
  doc.cellInitialize();
  doc.setFontSize(10.5); 
  doc.setFontStyle('bold');
  doc.text('REPORTE DE INSCRIPCIONES', 290, 30, null, null, 'center');
  doc.setFontStyle('normal');
  doc.text('Usuario: '+us, 290, 40, null, null, 'center');
  doc.text('Del:   '+fi+'   al    '+ff, 290, 50, null, null, 'center');
  doc.setFontStyle('bold');

  doc.cell(20,55,25,18,"Nro",0,'cell');
  doc.cell(20,55,45,18,"Fecha",0,'center');
  doc.cell(20,55,45,18,"Documento",0,'center');
  doc.cell(20,55,150,18,"Estudiante",0,'top');
  doc.cell(20,55,40,18,"Telefono",0,'top');
  doc.cell(20,55,240,18,"Programa",0,'top');
  doc.setFontStyle('normal');
  doc.setFontSize(10);

  window.console.log( window.stringifyObject(inscripciones[0]) )
  inscripciones.forEach( function(e,i){
    doc.cell(20,70,25,27,""+(i+1),i+1,'cell');
    doc.cell(20,70,45,27,parseFecha2(e.fecha_registro),i+1,'center');
    doc.cell(20,70,45,27,parseDoc(e.estudiante),i+1,'center');
    doc.setFontSize(9);
    doc.cell(20,70,150,27,parseNombre(e.estudiante),i+1,'top');
    doc.setFontSize(10);
    doc.cell(20,70,40,27,parseTel(e.estudiante),i+1,'top');
    doc.cell(20,70,240,27,parsePrograma(e.programa),i+1,'top');
    /*doc.cell(20,70,100,27,parseDir(e.direccion),i+1,'top');*/
  });

  doc.output("dataurlnewwindow");
}

function parseFecha( fe ){
  var vs = fe.split('-');
  return vs[2]+"/"+vs[1]+"/"+vs[0];
}

function parseFecha2( fe ){
  var date = new Date( fe );
  var d = date.getDate();
  var m = date.getMonth()+1;
  if( d < 10 ) d = '0'+d;
  if( m < 10 ) m = '0'+m;
  return d+"/"+m+"/"+date.getFullYear();
}

function parseNombre( ase ){
  if( ase == null ) return '-';
  var n = ase.nombres+' '+ase.pri_apellido;
  if( ase.seg_apellido ) n += ' '+ase.seg_apellido;
  n = n.toUpperCase();
  return n;
}

function parsePrograma( p ){
  if( p == null ) return " ";
  var cat = p.postgrado.categoria.nombre;
  var nom = p.nombre_compuesto;
  nom = nom.replace('- '+cat,'');
  if( nom.length > 68 ){
    var ps = wordWrapToStringList( nom,68 );
    nom = '';
    ps.forEach( function(e){
      nom += e+'\n';  
    })
  }
  return nom;
}

function parseTel( es ){
  if( es == null ) return " ";
  else if( es.telefono1 == null ) return " ";
  return es.telefono1;
}

function parseDoc( es ){
  if( es == null ) return " ";
  else if( es.num_doc == null ) return " ";
  var ext = '-';
  if( es.departamento != null ) ext = es.departamento.extension;
  return es.num_doc+" "+ext;
}

function wordWrapToStringList (text, maxLength) {
  var result = [], line = [];
  var length = 0;
  text.split(" ").forEach(function(word) {
      if ((length + word.length) >= maxLength) {
          result.push(line.join(" "));
          line = []; length = 0;
      }
      length += word.length + 1;
      line.push(word);
  });
  if (line.length > 0) {
      result.push(line.join(" "));
  }
  return result;
}







